import { render } from "./ChangePassword.vue?vue&type=template&id=2b4c67ea&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&lang=ts"

import "./ChangePassword.vue?vue&type=style&index=0&id=2b4c67ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b4c67ea"

export default script